import { BACKEND_URL_PREFIX } from "../utils/const";
import {
  NETWORK_REQUEST_SENT,
  FACULTY_LIST_FETCH_COMPLETED,
  FACULTY_FETCH_COMPLETED,
  FACULTY_TEACHERS_FETCH_COMPLETED,
  SET_FACULTY_LOADING,
} from "./types";
import { buildDefaultHeaders } from "./helper";
import { checkAndUpdateToken } from "./auth";

// TODO mto dashbord
export const list = (urlPrefixMTO, page = 0, limit = 1000) => async (dispatch, getState) => {
  // await dispatch(checkAndUpdateToken());
  // if (getState().auth.token) {
  const offset = page * limit;
  const url = urlPrefixMTO
    ? `${urlPrefixMTO}faculty?limit=${limit}&offset=${offset}`
    : `${BACKEND_URL_PREFIX}/faculty?limit=${limit}&offset=${offset}&web=1`;

  const response = await fetch(url, buildDefaultHeaders(getState));

  dispatch({ type: NETWORK_REQUEST_SENT, response });

  if (response.ok) {
    const result = await response.json();
    const items = result.items || result;
    const sortedList = Array.isArray(items)
      ? items.sort((a, b) => Number(a.faculty.split(' ')[0]) - Number(b.faculty.split(' ')[0]))
      : [];

    dispatch({
      type: FACULTY_LIST_FETCH_COMPLETED,
      list: sortedList,
      total: result.total || sortedList.length,
      pageCount: Math.ceil((result.total || sortedList.length) / limit)
    });
  }
  // }
};

export const listWithFiles = () => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/methodical/faculty`,
      buildDefaultHeaders(getState)
    );

    dispatch({ type: NETWORK_REQUEST_SENT, response });

    if (response.ok) {
      const result = await response.json();
      dispatch({ type: FACULTY_LIST_FETCH_COMPLETED, list: result.methodicalfaculty });
    }
  }
};

export const faculty = (id) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: SET_FACULTY_LOADING, payload: true })
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/faculty/${id}`,
      buildDefaultHeaders(getState)
    );

    dispatch({ type: NETWORK_REQUEST_SENT, response });

    if (response.ok) {
      const data = await response.json();
      dispatch({ type: FACULTY_FETCH_COMPLETED, faculty: data.faculty[0] });
    }
    dispatch({ type: SET_FACULTY_LOADING, payload: false })
  }
};

export const teachers = () => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/users/teachers`,
      buildDefaultHeaders(getState)
    );

    dispatch({ type: NETWORK_REQUEST_SENT, response });

    if (response.ok) {
      const data = await response.json();
      dispatch({ type: FACULTY_TEACHERS_FETCH_COMPLETED, teachers: data });
    }
  }
};
